"use strict";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var pie_1 = __importDefault(require("../charts/pie"));

var bars_1 = __importDefault(require("../charts/bars"));

var bars_grouped_1 = __importDefault(require("../charts/bars-grouped"));

var bars_stacked_1 = __importDefault(require("../charts/bars-stacked"));

var bars_horizontal_1 = __importDefault(require("../charts/bars-horizontal"));

var bars_grouped_horizontal_1 = __importDefault(require("../charts/bars-grouped-horizontal"));

var bars_stacked_horizontal_1 = __importDefault(require("../charts/bars-stacked-horizontal"));

var line_1 = __importDefault(require("../charts/line"));

var line_multi_1 = __importDefault(require("../charts/line-multi"));

var scatter_1 = __importDefault(require("../charts/scatter"));

var constants_1 = require("../charts/constants");

var constants_2 = require("../helpers/wiget-helper/constants");

var VegaService =
/*#__PURE__*/
function () {
  function VegaService(store) {
    _classCallCheck(this, VegaService);

    this.store = store;
    this.schema = constants_2.defaultVegaSchema();
  }

  _createClass(VegaService, [{
    key: "resolveChart",
    value: function resolveChart() {
      var _a, _b, _c, _d, _e;

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee() {
        var configuration, chartType, Chart, chart;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                configuration = this.store.configuration;
                chartType = configuration.chartType;
                _context.t0 = chartType;
                _context.next = _context.t0 === "pie" ? 5 : _context.t0 === "donut" ? 5 : _context.t0 === "bar-horizontal" ? 7 : _context.t0 === "stacked-bar-horizontal" ? 9 : _context.t0 === "bar" ? 11 : _context.t0 === "stacked-bar" ? 13 : _context.t0 === "line" ? 15 : _context.t0 === "scatter" ? 17 : 19;
                break;

              case 5:
                Chart = pie_1["default"];
                return _context.abrupt("break", 20);

              case 7:
                Chart = ((_a = configuration.color) === null || _a === void 0 ? void 0 : _a.identifier) ? bars_grouped_horizontal_1["default"] : bars_horizontal_1["default"];
                return _context.abrupt("break", 20);

              case 9:
                Chart = ((_b = configuration.color) === null || _b === void 0 ? void 0 : _b.identifier) ? bars_stacked_horizontal_1["default"] : bars_horizontal_1["default"];
                return _context.abrupt("break", 20);

              case 11:
                Chart = ((_c = configuration.color) === null || _c === void 0 ? void 0 : _c.identifier) ? bars_grouped_1["default"] : bars_1["default"];
                return _context.abrupt("break", 20);

              case 13:
                Chart = ((_d = configuration.color) === null || _d === void 0 ? void 0 : _d.identifier) ? bars_stacked_1["default"] : bars_1["default"];
                return _context.abrupt("break", 20);

              case 15:
                Chart = ((_e = configuration.color) === null || _e === void 0 ? void 0 : _e.identifier) ? line_multi_1["default"] : line_1["default"];
                return _context.abrupt("break", 20);

              case 17:
                Chart = scatter_1["default"];
                return _context.abrupt("break", 20);

              case 19:
                throw new Error("Chart of type: ".concat(chartType, " is not supported. we support: (").concat(constants_1.SUPPORTED_CHARTS.join("|"), ")"));

              case 20:
                _context.next = 22;
                return new Chart(this.store).getChart();

              case 22:
                chart = _context.sent;
                this.schema = Object.assign(Object.assign({}, this.schema), chart);

              case 24:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
    }
  }, {
    key: "setConfig",
    value: function setConfig() {
      var _a;

      var widgetConfig = this.store.widgetConfig;
      this.schema = Object.assign(Object.assign({}, this.schema), {
        config: Object.assign(Object.assign({}, this.schema.config), (_a = widgetConfig === null || widgetConfig === void 0 ? void 0 : widgetConfig.config) !== null && _a !== void 0 ? _a : {})
      });
    }
  }, {
    key: "getChart",
    value: function getChart() {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee2() {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                this.setConfig();
                _context2.next = 3;
                return this.resolveChart();

              case 3:
                return _context2.abrupt("return", this.schema);

              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));
    }
  }]);

  return VegaService;
}();

exports["default"] = VegaService;